var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wc-sidebar h-100 border-right border-secondary"},[_c('div',{staticClass:"text-primary pt-4",attrs:{"role":"list"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }